<div class="modalOutorga" [formGroup]="form">
  <h1 mat-dialog-title class="titulo">Trocar Outorga</h1>
  <div mat-dialog-content>
    <label id="tipoDocOutorga">Tipo de inscrição: </label>
    <mat-radio-group aria-labelledby="tipoDocOutorga" class="radio-group" (change)="mascarar()" formControlName="tipoDocumento">
      <mat-radio-button color="primary" class="radio-button" *ngFor="let tpDoc of tiposDoc" [value]="tpDoc.value">
        {{tpDoc.label}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div mat-dialog-content >
    <mat-form-field class="example-full-width" *ngIf="this.tipoDocumento.value">
      <mat-label id="numDocOutorga">Número de Inscrição</mat-label>
        <input matInput formControlName="inscricao" mask="{{mascara}}" />
    
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="botoes">
    <button *ngIf="this.tipoDocumento.value && this.inscricao.value " mat-raised-button color="primary" 
          (click)="trocarOutorga()">Buscar</button>
    <button mat-raised-button class="md-icon-button btnNok" (click)="onClose()">
      <img class="img-fluid" src="assets/icons/white_close_icon.png"  width="16px"/> Fechar
    </button>
  </div>
</div>